import React from 'react';
import { productShape } from 'shapes';
import { useWishList, useGTM } from 'hooks';
import { ProductCard } from 'components';

export default function ProductCardContainer({ product, ...otherProps }) {
    const [
        { isInWishList, showIconWishlist },
        { openWishlistModal },
    ] = useWishList(product.objectID);
    const [, pushToGTM] = useGTM();

    return (
        <ProductCard
            {...otherProps}
            product={product}
            withWishlist={showIconWishlist}
            activeWishlist={isInWishList}
            onWishlistClick={openWishlistModal}
            onPushToGTM={pushToGTM}
        />
    );
}

ProductCardContainer.propTypes = {
    product: productShape.isRequired,
};
